define( function() {
	"use strict";

	return ( /^margin/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/rmargin.js
// module id = 1818
// module chunks = 36